import { render } from "./WeeklyTargetPolicy.vue?vue&type=template&id=a8dd54ea"
import script from "./WeeklyTargetPolicy.vue?vue&type=script&lang=js"
export * from "./WeeklyTargetPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__